import { authHttp } from '../http'
import * as receiveRoutes from '../../routes/receive-vehicle.routes'
import * as registrationRoutes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'

export async function getClientByCnpj(cnpj) {
  try {
    const response = await authHttp().get(registrationRoutes.urlGetClientByCnpj(cnpj))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postNotaFiscalDevolucaoParcial(
  client_id,
  invoice_number,
  invoice_path,
  tp_id,
) {
  try {
    const response = await authHttp().post(receiveRoutes.urlPostNotaFiscalDevolucaoParcial, {
      client_id,
      invoice_number,
      invoice_path,
      tp_id,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteFileNotaFiscalDevolucaoParcial(
  filename,
  client_returned_invoice_id,
  delivery_step_id,
) {
  try {
    const response = await authHttp().delete(
      receiveRoutes.urlDeleteFileNfDevolucaoParcial(
        filename,
        client_returned_invoice_id,
        delivery_step_id,
      ),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteNotaFiscalDevolucaoParcial(invoice_id) {
  try {
    const response = await authHttp().delete(receiveRoutes.urlDeleteNfDevolucaoParcial(invoice_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getNotasFiscaisDevolucaoParcialByStep(delivery_step_id) {
  try {
    const response = await authHttp().get(
      receiveRoutes.urlGetNfsDevolucaoParcialByStep(delivery_step_id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getNotaFiscalDevolucaoParcial(invoice_id) {
  try {
    const response = await authHttp().get(receiveRoutes.urlGetNfDevolucaoParcial(invoice_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
